import React, {PureComponent as Component} from 'react';

import FormManager from "../../../ui/template/Form/FormManager";
import Submit from "../../../ui/template/Form/Submit";
import Alerts from "../../../ui/template/Alert/Alerts";
import {MCbrowser} from "../../Context/browserContext";
import {Check, Image, Trash2, X} from "react-feather";
import DropZone from "../../../ui/template/Drag/DropZone";
import memberFileUploadApi from "../MemberFileUploadApi";
import postPicMemberApi from "./Api/postPicMember";
import postPicMemberDeleteApi from "./Api/postPicMemberDelete";


class   EditPic  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;
        this.handlePostUp = this.postUp.bind(this);
        this.form1=React.createRef();
        this.formAlerts=React.createRef();

        this.form2=React.createRef();
        this.formAlerts2=React.createRef();
        this.handlePostUp2 = this.postUp2.bind(this);

        this.HuploadDelete = this.uploadDelete.bind(this);
        this.HpostUpload = this.postUpload.bind(this);
        this.HreceivedFile = this.receivedFile.bind(this);

        this.receivedFileId=-1;
        this.uploadedFileId=-1;

        this.dropZone=React.createRef();
        this.userImgRef=React.createRef();
        this.props=props;
    }


    uploadDelete(obj){
        if(obj.state!=="uploading") {
            this.dropZone.current.deleteItem(obj.id);
            this.receivedFileId=-1;
            this.uploadedFileId=-1;
        }
    }

    receivedFile(id){
        this.receivedFileId=id;
        this.uploadedFileId=-1;
    };


    async postUpload(fileData,fileId) {
        if(this.isAlive) {
            if (this.form1.current.isAlive) this.form1.current.setDisable();
            let pageAlerts = this.context.pageAlerts;
            this.dropZone.current.HchangeStateItem(fileId, "uploading");
            let res = await memberFileUploadApi(fileData, fileId, pageAlerts, this.dropZone.current.HuploadProgress);
            if(this.isAlive) {
                if (res.hasOwnProperty("id")) {
                    let id = res.id;
                    if (id > 0) {
                        this.uploadedFileId=id;
                        this.dropZone.current.HchangeStateItem(fileId,"uploaded",null,null);
                        await this.postingUp(id);
                    }
                }
                if (this.form1.current.isAlive) this.form1.current.setEnable();
            }
        }
    }


    async postingUp(id) {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await postPicMemberApi(id , pageAlerts,this.formAlerts);
        if(l===true){
            this.userImgRef.current.src = "http://mdyaran.ir/membership/picture?" + new Date().getTime();
            let page = this.context.page;
            page.dispatcher.run("route", "profilePic", "changed");
        }
    }

    async postUp2() {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await postPicMemberDeleteApi( pageAlerts,this.formAlerts2);
        if(l===true){
            this.userImgRef.current.src = "http://mdyaran.ir/membership/picture?" + new Date().getTime();
            let page = this.context.page;
            page.dispatcher.run("route", "profilePic", "changed");
        }
    }


    async postUp() {
        if( this.receivedFileId>=0 && this.uploadedFileId<=0) {
            await this.dropZone.current.getFileData(this.HpostUpload, this.receivedFileId);
        }else{
            if(this.uploadedFileId>0) {
                await this.postingUp(this.uploadedFileId);
            }
        }
    }

    render() {

            return ( <>
                        <div className="mb-3 border rounded bg-white profile-box text-center w-10">
                            <div className="p-4 d-flex align-items-center">
                                <img ref={this.userImgRef} src="/images/avatar.jpg" data-src="http://mdyaran.ir/membership/picture"
                                     className="lazyload blur-up img-fluid rounded-circle mw150"/>
                                <div className="p-4">
                                    <button   className="btn btn-info m-0 mx-1"  data-toggle="modal" data-target="#editPicModal">
                                        <Image size={16} />
                                    </button>
                                    <button   className="btn btn-danger mx-1" data-toggle="modal" data-target="#deletePicModal">
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <FormManager   ref={this.form1} submit={this.handlePostUp}>
                            <div className="modal fade" id="editPicModal" tabIndex="-1" role="dialog"
                                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog  modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                               بارگزاری تصویر پروفایل
                                            </h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <X />
                                            </button>
                                        </div>
                                        <div className="modal-body">

                                            <DropZone openFileStr="بارگزاری تصویر" ref={this.dropZone} deleteingItem={this.HuploadDelete}
                                                      receivedFile={this.HreceivedFile} isEdit={false} isBtnDirectory={false} isMultiple={false} maxFiles={1} />
                                            <Alerts layout="relative" ref={this.formAlerts} />
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                                بستن
                                            </button>
                                            <Submit className="btn btn-primary">
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                ثبت
                                                <Check size={16} className="ml-2" />
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                            </Submit>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FormManager>
                        <FormManager   ref={this.form2} submit={this.handlePostUp2}>
                            <div className="modal fade" id="deletePicModal" tabIndex="-1" role="dialog"
                                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog  modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                بارگزاری تصویر پروفایل
                                            </h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <X />
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <p className="font-10 line-h-2 mb-4 mt-4">
                                                آیا شما قصد حذف تصویر پروفایل خود را دارید؟
                                            </p>
                                            <Alerts layout="relative" ref={this.formAlerts2} />
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                                بستن
                                            </button>
                                            <Submit className="btn btn-primary">
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                حذف تصویر
                                                <Check size={16} className="ml-2" />
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                            </Submit>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FormManager>
            </>);

    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

EditPic.contextType = MCbrowser;

export default EditPic;
